import { Backdrop, Stack } from "@mui/material";
import Lottie from "lottie-react";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { PLUGIN_NAME } from "config/const";

import loadingMyBee from "../assets/lotti/mybee.json";
import loadingEnergy from "../assets/lotti/Energy.json";
import loadingMeter from "../assets/lotti/meter.json";
import loadingService from "../assets/lotti/service.json";

const LazyLoadLoading = () => {
  const selectedPlugin = useSelector((state) => state?.userSettings?.selectedPlugin);
  const [lotti, setLotti] = useState(null);

  useEffect(() => {
    if (selectedPlugin === PLUGIN_NAME.SERVICES_CALL) {
      setLotti(loadingService);
    } else if (selectedPlugin === PLUGIN_NAME.MICRO_CONTROLLERS) {
      setLotti(loadingEnergy);
    } else if (selectedPlugin === PLUGIN_NAME.METER_READ) {
      setLotti(loadingMeter);
    } else {
      setLotti(loadingMyBee);
    }
  }, [selectedPlugin]);

  return (
    <Backdrop
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 500,
        "&.MuiBackdrop-root": {
          bgcolor: "rgba(0 , 0, 0, 0.1)",
          backdropFilter: "blur(2px)",
        },
      }}
      open={true}
    >
      <Stack
        bgcolor="white"
        alignItems="center"
        justifyContent="center"
        borderRadius={100}
        paddingTop={1}
        paddingX={1}
        maxWidth={170}
      >
        <Lottie animationData={lotti} loop={true} />
      </Stack>
    </Backdrop>
  );
};
export default LazyLoadLoading;
